// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1GhQK","Label":"Input_Label__tD2Kf","InputElement":"Input_InputElement__SRsVy","Invalid":"Input_Invalid__36EVW"};